import React from "react";
import IMAGES from "../../constants/images";

export default function NoAppointments() {
  return (
    <div className="w-full p-3">
      <div className="w-full flex flex-col items-center justify-center p-3 text-center">
        {/* Image */}
        <img
          src={IMAGES.no_chart_data}
          alt="No Appointments"
          className="h-[140px] mb-2"
        />
      </div>
      {/* Heading */}
      <h2 className="w-full text-center text-base font-medium text-[#4B61FF] mt-6 mb-4 font-poppins">
        Once you start seeing patients, your session analytics will appear here
      </h2>
      {/* Description */}
      <p className="text-[#334155] text-center text-sm font-poppins">
        Stay consistent to build insights on your care delivery.
      </p>
    </div>
  );
}
